export function ConvertToContactList(_contactList: any) {
  const contactList = [];
  if (_contactList !== null) {
    for (let i = 0; i < _contactList.length; i++) {
      const contactData = {
        id: _contactList[i].id,
        contactBranchCode: _contactList[i].contactBranchCode,
        contactTaxId: _contactList[i].contactTaxId,
        contactCode: _contactList[i].contactCode,
        contactFullName: _contactList[i].contactFullName,
        contactFullNameEng: _contactList[i].contactFullNameEng,
        contactFullNameTh: _contactList[i].contactFullNameTh,
        contactShortName: _contactList[i].contactShortName,
        contactShortNameEng: _contactList[i].contactShortNameEng,
        contactShortNameTh: _contactList[i].contactShortNameTh,
        contactName: _contactList[i].contactName,
        contactType: _contactList[i].contactType,
        country: _contactList[i].country,
        incomeDueDateTypeId: _contactList[i].incomeDueDateTypeId,
        incomeDueDateDay: _contactList[i].incomeDueDateDay,
        outflowDueDateTypeId: _contactList[i].outflowDueDateTypeId,
        outflowDueDateDay: _contactList[i].outflowDueDateDay,
        address: _contactList[i].address,
        phoneNumber: _contactList[i].contactPhoneNumber,
        email: _contactList[i].contactEmail,
        webSite: _contactList[i].contactWebSite,
        personFirstName: _contactList[i].personFirstName,
        personLastName: _contactList[i].personLastName,
        personNickName: _contactList[i].personNickName,
        personEmail: _contactList[i].personEmail,
        personPhone: _contactList[i].personPhone,
        contactWhtType: _contactList[i].contactWhtType,
        status: "null",
        logoUrl: _contactList[i].logoUrl,
        accountsPayableAccountId: _contactList[i].accountsPayableAccountId,
        accountsReceivableAccountId: _contactList[i].accountsReceivableAccountId,
        isDeleted: _contactList[i].isDeleted,
        isArchived: _contactList[i].isArchived,
        isFavorite: false,
        sortNumber: 0,
        isSuggest: false,
        creditLimit: _contactList[i].creditLimit,
        creditLimitSettingType: _contactList[i].creditLimitSettingType,
      };
      contactList.push(contactData);
    }
  }
  return contactList;
}

export function ConvertToContactSearchFirst(_contactList: any) {
  const contactList = [];
  if (_contactList !== null) {
    for (let i = 0; i < _contactList.length; i++) {
      const contactData = {
        contactBranchCode: _contactList[i].contactBranchCode,
        contactCode: _contactList[i].contactCode,
        contactEmail: _contactList[i].contactEmail,
        contactFirstName: _contactList[i].contactFirstName,
        contactFullName: _contactList[i].contactFullName,
        id: _contactList[i].contactId,
        contactLastName: _contactList[i].contactLastName,
        contactName: _contactList[i].contactName,
        contactNickName: _contactList[i].contactNickName,
        contactPersonEmail: _contactList[i].contactPersonEmail,
        contactPersonPhone: _contactList[i].contactPersonPhone,
        contactPhone: _contactList[i].contactPhone,
        contactShortName: _contactList[i].contactShortName,
        contactTaxId: _contactList[i].contactTaxId,
        contactType: _contactList[i].contactType,
        contactWebsite: _contactList[i].contactWebsite,
        personalNamePrefixOther: _contactList[i].personalNamePrefixOther,
        personalNamePrefixTypeId: _contactList[i].personalNamePrefixTypeId,
      };
      contactList.push(contactData);
    }
  }
  return contactList;
}
